export const Colors = {
    heading: '#ff2424',
    bgText: '#CBD5E0',
    bgMain: '#b5b4b3',
    bgBrown: '#aaa399',
    bgBlue: '#020717',
    bgBlack: '#050402'
}